import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { JwtService } from 'taxtank-core/common';

/**
 * hides some interface elements for co-owner with view-only access
 * the implementation is very similar to *ngIf directive
 */
@Directive({
  selector: '[appImpersonatorAccess]',
  standalone: false
})
export class ImpersonatorAccessDirective {
  private hasAccess: boolean;
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private jwtService: JwtService) {}

  @Input() set appImpersonatorAccess(username: string) {
    this.hasAccess = username === this.jwtService.decode().username;
    if (this.hasAccess) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

  @Input() set appImpersonatorAccessElse(templateRef: TemplateRef<any>) {
    if (!this.hasAccess) {
      this.viewContainer.createEmbeddedView(templateRef);
    }
  }
}
